<script lang="ts">
    import { get,  writable } from "svelte/store";
    import SelectableTable from "../../components/Table/SelectableTable.svelte";  
    import { PermissionService } from "../../utils/misc/permission-utils";
    import { user } from "../../app.store";
    import {
      loading_projects,
      record, records, initCompanyProjectsList, onEdit,filter,loadProjects
    } from "./company.projects.store";
    import { onMount } from "svelte";
    import { companyActionDtoFields } from "../../utils/TableFields/company-action-dto.fields";
    import type { IProjectAction } from "../../entities/project-action";
    import Table from "../../components/Table/Table.svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  
    export let oid: number;
   
    const editing = writable<boolean>(false);
    const sendModalOpen = writable<boolean>(false);
    const confirmModalOpen = writable<boolean>(false);
    const selected = writable<IProjectAction[]>([]);
    let targets = [];   
  
    const selectedresend = writable<IProjectAction>();

    onMount(() => initCompanyProjectsList(oid));
  

  function searchProjects(oid: number): void {
    console.log("searchProjects "+oid);
    loadProjects(oid);
  }
  function resetSearchProjects(): void {
    loadProjects(oid);
  }
</script>
  
  <SearchHeader
  entitySingular="progetto/azione"
  entityPlural="progetti/azioni"
  numRecords={$records.length}
  bind:searchValue={$filter.criteria.query}
  on:search={() => searchProjects(oid)}
  on:reset={() => resetSearchProjects()}      
  clearButtonVisible={true}
/>
  
      <Table
      loading={$loading_projects}
      fields={companyActionDtoFields}
      records={$records}
      pagination={null}
      createEnabled={false}
      showEnabled={true}
      deleteEnabled={false}
      downloadEnabled={false}
      customEnabled={false}
      on:show={(e) => onEdit(e)}
    />
    
  
    
   